export default class Scheduler {
  private dispatch: any;
  private timers: Map<number, any>;

  constructor(dispatch) {
    this.dispatch = dispatch;
    this.timers = new Map();
  }

  executeEvery({ period, id, action, params = {} }) {
    this.cancel(id);
    this.timers.set(
      id,
      setInterval(() => this.dispatch(action(params)), period)
    );
  }

  private cancel(id) {
    const timer = this.timers.get(id);
    if (timer) {
      clearTimeout(timer); // also clears interval
    }

    return this.timers.delete(id);
  }
}
